module.exports = __webpack_public_path__ + "img/冷库温度显示装置检定报告_01.6b061985.png";